<app-popup [trigger]="ui.open()" heading="My Reminders" size="sm" (handleClose)="close()">
  <div class="rm-pane">
    @if (!composerOpen()) {
      <app-button class="rm-composer-open" variant="outlined" tone="neutral" [fullWidth]="true" icon="add-m" iconWidth="16px"
        iconHeight="16px" title="Add reminder" extraClass="rm-composer-btn" (btnOnClick)="openComposer()" />
    } @else {
      <form class="rm-form" (submit)="$event.preventDefault(); submit()">
        <div class="rm-form-head">
          <span class="rm-form-title">{{ editing() ? 'Edit reminder' : 'New reminder' }}</span>
          <app-button variant="text" tone="neutral" size="xs" [iconOnly]="true" icon="cross" iconWidth="14px" iconHeight="14px"
            ariaLabel="Close" (btnOnClick)="cancelComposer()" />
        </div>
        <app-input title="Title" name="title" [value]="form().title ?? ''" [error]="formError().title" (handleChange)="handleFormChange($event)" />
        <app-date-picker-new
          title="Remind at"
          name="remind_at"
          [value]="form().remind_at ?? ''"
          [futureDateTime]="true"
          [error]="formError().remind_at"
          (handleDateChange)="handleFormChange($event)"
        />
        <app-dropdown
          title="Remind"
          name="recipient_user_ids"
          [items]="usersList()"
          bindLabel="name"
          bindValue="id"
          [multiSelect]="true"
          [wrap]="true"
          [selectedOption]="form().recipient_user_ids ?? []"
          [error]="formError().recipient_user_ids"
          (handleOptionChange)="handleRecipientsChange($event)"
        />
        <div class="rm-form-actions">
          <app-button type="button" variant="ghost" tone="neutral" size="xs" title="Cancel" (btnOnClick)="cancelComposer()" />
          <app-button type="submit" size="xs" [title]="editing() ? 'Save changes' : 'Add reminder'" [isLoading]="saving()" />
        </div>
      </form>
    }

    <div class="rm-filters">
      <app-segment-toggle-switch-button [options]="stateSegments()" [value]="state()" size="xs" [fullWidth]="true" (changed)="setState($event)" />
      <div class="rm-filters-row">
        <app-segment-toggle-switch-button [options]="scopeSegments" [value]="scope()" size="xs" (changed)="setScope($event)" />
        <app-button variant="text" tone="neutral" size="xs" [iconOnly]="true" icon="refresh" iconWidth="15px" iconHeight="15px"
          ariaLabel="Refresh" [disabled]="loading()" [extraClass]="loading() ? 'rm-refresh spinning' : 'rm-refresh'" (btnOnClick)="load()" />
      </div>
    </div>

    <div class="rm-scroll" [class.is-loading]="loading()" [attr.aria-busy]="loading()">
      @for (g of groups(); track g.key) {
        <div class="rm-group-head">
          {{ g.label }}
          <span class="rm-group-count">{{ g.rows.length }}</span>
        </div>
        @for (r of g.rows; track r.id) {
          <app-reminder-row
            [reminder]="r"
            [now]="nowTick()"
            [busy]="busyId() === r.id"
            [editing]="editing()?.id === r.id"
            [focused]="ui.focusId() === r.id"
            [snoozeOpen]="snoozeOpenId() === r.id"
            (dismiss)="dismiss($event)"
            (snoozeToggle)="toggleSnooze($event)"
            (snooze)="snooze($event.reminder, $event.minutes)"
            (edit)="startEdit($event)"
            (remove)="askDelete($event)"
          />
        }
      }

      @if (loading() && !list().length) {
        <div class="rm-empty">Loading…</div>
      }
      @if (!loading() && !list().length) {
        <app-empty-state icon="notification" [title]="emptyState().title" [message]="emptyState().message" />
      }
      @if (hasMore()) {
        <div class="rm-more">
          <app-button variant="text" tone="neutral" size="xs" title="Show more" [isLoading]="loadingMore()" (btnOnClick)="loadMore()" />
        </div>
      }
    </div>
  </div>
</app-popup>

<app-confirmation-dialog
  [trigger]="deleteDialog().trigger"
  [id]="deleteDialog().id"
  theme="danger"
  title="Delete reminder"
  message="This removes the reminder for every recipient. Continue?"
  [isLoading]="deleteDialog().isLoading"
  (onConfirm)="confirmDelete()"
  (onCancel)="closeDelete()"
  (onClose)="closeDelete()"
/>
